/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleMetadataProperty } from './moduleMetadataProperty';
import type { ModuleCourses } from './moduleCourses';
import type { ModuleAuthor } from './moduleAuthor';
import type { ModuleState } from './moduleState';
import type { ModuleGrading } from './moduleGrading';
import type { ModuleGradingConfigSnapshot } from './moduleGradingConfigSnapshot';
import type { ModuleImageUrl } from './moduleImageUrl';
import type { ModuleIsDeprecated } from './moduleIsDeprecated';
import type { ModuleMandates } from './moduleMandates';
import type { ModuleUpgradeOfferProperty } from './moduleUpgradeOfferProperty';
import type { ModuleExamAttempt } from './moduleExamAttempt';

/**
 * Representation of a module
 */
export interface Module {
  id: string;
  version?: string;
  title: string;
  metadata: ModuleMetadataProperty;
  /** DEPRECATED: Do not use for navigation. List of courses this module belongs to. */
  courses?: ModuleCourses;
  author?: ModuleAuthor;
  state: ModuleState;
  grading?: ModuleGrading;
  gradingConfigSnapshot?: ModuleGradingConfigSnapshot;
  imageUrl?: ModuleImageUrl;
  isDeprecated?: ModuleIsDeprecated;
  mandates?: ModuleMandates;
  upgradeOffer?: ModuleUpgradeOfferProperty;
  examAttempt?: ModuleExamAttempt;
}
